import { Skeleton } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

const WebTopCategories: React.FC<{ category: string; loader: boolean; data: { images: string; id: string; name: string }[] | null }> = ({
    category = "", loader = false, data = null
}) => {
    return (
        <div>
            <h2 className='font-size-28px font-Poppins-SemiBold theme-color-green'>Top Categories</h2>
            <div className='top-categories-main'>
                {loader ?
                    Array.from({ length: 6 }).map((_, index) => (
                        <div key={index} className='flex gap-2 flex-col items-center'>
                            <Skeleton variant="circular" className="top-categories-img aspect__square" />
                            <Skeleton variant="text" className="min-w-[100px]" />
                        </div>
                    ))
                    :
                    data?.map((item, index) => (
                        <div key={index} className='flex gap-2 flex-col items-center'>
                            <Link to={`/pharmacy/${category}/${item?.id}/view`} className='top-categories-img'>
                                <img
                                    src={`${item?.images}`}
                                    alt='banner-dummy-pic'
                                />
                            </Link>
                            <span className="font-size-18px font-Poppins-SemiBold theme-color-green">{item?.name || "-"}</span>
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

export default WebTopCategories;